module.exports = __webpack_public_path__ + "img/play-phone-kh.786a3513.png";